import { alpha, Box, Typography } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { DualRing } from "react-spinners-css";
import ViewTxOnBSC from "src/components/BscExplorer/ViewTxOnBSC.jsx";
import { TxStatus } from "src/configs/constance";
import { selectTxStatus } from "src/redux/tx-status-slice";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: 30,
    left: 8,
    zIndex: 1301,
  },
  container: {
    backgroundColor: alpha("#284881", 0.8),
    padding: theme.spacing(0.5, 2),
    borderRadius: 4,
  },
  type: {
    textTransform: "capitalize",
    fontWeight: 500,
  },
  content: {
    fontWeight: 500,
  },
  success: {
    color: "#25ab0d",
  },
  error: {
    color: "#f44336",
  },
}));

export default function TransactionStatus() {
  const cls = useStyles();
  const txStatus = useSelector((state) => selectTxStatus(state));

  if (!txStatus) return <></>;

  return (
    <Box className={cls.root}>
      {txStatus.map((item) => (
        <Box key={item.id} mb={1} className={cls.container}>
          <Box position="relative">
            <Typography component="div" className={cls.type}>
              {item.type}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" py={0.5}>
            <Box display="flex" alignItems="center" mr={1}>
              {(item.status === TxStatus.WAIT_USER_CONFIRM_TX || item.status === TxStatus.TX_EXECUTING) && (
                <DualRing color="#fff" size={30} />
              )}
              {item.status === TxStatus.TX_SUCCESS && <DoneIcon style={{ color: "#25ab0d" }} />}
              {item.status === TxStatus.TX_FAILED && <ClearIcon color="error" />}
            </Box>
            <Box>
              <Typography
                className={clsx(cls.content, {
                  [cls.success]: item.status === TxStatus.TX_SUCCESS,
                  [cls.error]: item.status === TxStatus.TX_FAILED,
                })}
              >
                {item.status === TxStatus.WAIT_USER_CONFIRM_TX && "Wait for user confirm Transaction"}
                {item.status === TxStatus.TX_EXECUTING && "Executing Transaction"}
                {item.status === TxStatus.TX_SUCCESS && (
                  <>
                    Tx Hash: <ViewTxOnBSC txHash={item.txHash} component="span" variant="body1" />
                  </>
                )}
                {item.status === TxStatus.TX_FAILED && (
                  <>
                    Tx Hash: <ViewTxOnBSC txHash={item.txHash} component="span" variant="body1" />
                  </>
                )}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
